var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-footer"},[(_vm.event.description)?_c('div',{staticClass:"event-details",attrs:{"container":""}},[_c('markdown',{staticClass:"description col",attrs:{"source":_vm.event.description,"html":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }